import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";

const connectionString =
  "InstrumentationKey=39e09db9-94ba-4bde-aba9-d4535f549fae;IngestionEndpoint=https://uksouth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://uksouth.livediagnostics.monitor.azure.com/;ApplicationId=bb02d538-a194-4ad6-9f24-d5ece7e16f45";

const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    connectionString,
    enableAutoRouteTracking: true,
    extensions: [reactPlugin],
  },
});

appInsights.loadAppInsights();

type TrackableEvent =
  | "click_share"
  | "enter_registration"
  | "start_new_forecast";

export const trackButtonClick = (name: TrackableEvent, label?: string) => {
  appInsights.trackEvent({ name, properties: { label } });
};

export default appInsights;
